import Cookies from 'js-cookie';

const prefix = 'e-globe_';
const cookieinfo_accepted = 'cookieinfo_accepted';
const $cookieinfo = document.querySelector('section.cookie-info');
const cookieApi = Cookies.withAttributes({
    path: '/',
    expires: 365,
    secure: true,
});
const hide_cookieinfo = () => {
    $cookieinfo.classList.add('is-hidden');
};

// hide cookie info if cookie already set
if (parseInt(cookieApi.get(prefix + cookieinfo_accepted)) === 1) {
    hide_cookieinfo();
}

// or add event listener for the button, which stores the cookie and hides the info
else {
    $cookieinfo.querySelector('.button').addEventListener('click', e => {
        cookieApi.set(prefix + cookieinfo_accepted, 1);
        hide_cookieinfo();
    });
}